import { createContext, useContext, useState, useEffect } from 'react';
import { getCartItems } from '../api/cartApi';
import { isLoggedIn } from '../utils/tokenUtils';

const CartContext = createContext();

export function CartProvider({ children }) {
    const [cartCount, setCartCount] = useState(0);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [sidebarItems, setSidebarItems] = useState([]);

    const refreshCartCount = async () => {
        if (!isLoggedIn()) { setCartCount(0); return; }
        try {
            const res = await getCartItems();
            setCartCount(res.data.length);
            setSidebarItems(res.data);
        } catch { setCartCount(0); }
    };

    const openCartSidebar = async () => {
        await refreshCartCount();
        setSidebarOpen(true);
    };

    const closeCartSidebar = () => setSidebarOpen(false);

    useEffect(() => { refreshCartCount(); }, []);

    return (
        <CartContext.Provider value={{
            cartCount, refreshCartCount,
            sidebarOpen, sidebarItems,
            openCartSidebar, closeCartSidebar
        }}>
            {children}
        </CartContext.Provider>
    );
}

export const useCart = () => useContext(CartContext);